import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Redirect } from "react-router";
import LoaderCircle from "../../loader/LoaderCircle";
import FormBuilder from "../../../class/tool/FormBuilder";
import AutomaticDrawerController from "../../../stories/_setting/AutomaticDrawers/AutomaticDrawerController";
import LicenseController from "../../../stories/_account/Licenses/LicenseController";
import '../../../css/form/Form.css';

const FormStart = props => {
    const env = JSON.parse(localStorage.getItem("env"));
    const item = "automaticdrawers";
    const controller = new AutomaticDrawerController();
    const ref = useRef();
    const { object, handleIndex } = props;
    const [ reload, setReload ] = useState(false);
    const [ loadingLicenses, setLoadingLicenses ] = useState(true);
    const [ values, setValues ] = useState({});
    const [ errors, setErrors ] = useState([]);
    const [ saving, setSaving ] = useState(false);
    const [ globalError, setGlobalError ] = useState(null);
    const [ rows, setRows ] = useState([
        {
            label: "Nom",
            attribute: "name",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "Nom",
            emptyText: "Aucun"
        },
        {
            noLabel: true,
            label: "État",
            attribute: "active",
            inputType: "switch",
            returnType: "int",
            classnameInput: "marginTB"
        },
        {
            label: "Marque",
            attribute: "brand",
            inputType: "select",
            returnType: "string",
            list: [],
            dictionary: null,
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Modèle",
            attribute: "model",
            inputType: "select",
            returnType: "string",
            list: [],
            dictionary: null,
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            emptyText: "Aucun",
            hidden: true
        },
        {
            label: "Adresse IP",
            attribute: "ipAddress",
            inputType: "text",
            returnType: "string",
            list: [],
            dictionary: null,
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            emptyText: "Aucun",
            hidden: false
        },
        {
            noLabel: true,
            label: "Activer l'option monnayeur intelligent",
            attribute: "allowsSimultaneousOperation",
            inputType: "switch",
            returnType: "int",
            classnameInput: "marginTB"
        },
        {
            noLabel: true,
            label: "Autorise l'encaissement si injoignable",
            attribute: "allowsDisconnectedAutomaticDrawer",
            inputType: "switch",
            returnType: "int",
            classnameInput: "marginTB"
        },
        {
            noLabel: true,
            label: "Accepter les billets de 50",
            attribute: "usable50",
            inputType: "switch",
            returnType: "int",
            classnameInput: "marginTB"
        },
        {
            noLabel: true,
            label: "Accepter les billets de 100",
            attribute: "usable100",
            inputType: "switch",
            returnType: "int",
            classnameInput: "marginTB"
        },
        {
            noLabel: true,
            label: "Accepter les billets de 200",
            attribute: "usable200",
            inputType: "switch",
            returnType: "int",
            classnameInput: "marginTB"
        },
        {
            noLabel: true,
            label: "Accepter les billets de 500",
            attribute: "usable500",
            inputType: "switch",
            returnType: "int",
            classnameInput: "marginTB"
        },
        {
            label: "Licences",
            attribute: "licenses",
            returnType: "array",
            inputType: "tag",
            inputText: false,
            list: [],
            classnameLabel: "label",
            classname: "",
            placeholder: ""
        }
    ]);

    const getLicenses = () => {
        const controller = new LicenseController()
        controller._callback = handleGetLicenses
        controller.index(env)
    }
    const handleGetLicenses = (list, error, status) => {
        switch (status) {
            case 200:
                let rowsTmp = rows.slice()
                let licenses = []

                for (let item in list) {
                    licenses.push({
                        id: list[item].id,
                        type: "license",
                        object: list[item]
                    })
                }

                rowsTmp[rowsTmp.findIndex(_ => _.attribute === "licenses")].list = licenses
                setRows(rowsTmp)
                break
            default:
                setGlobalError("Impossible de récupérer la liste des licences")
                break
        }

        setLoadingLicenses(false)
    }
    const getModelsByBrand = () => {
        let models = [
            {
                value: "Modèle",
                id: null
            },
            {
                value: "----------",
                id: null
            }
        ]
        let filtered = AutomaticDrawerController._drawers.filter((m) => m.brand === values.brand)

        for(let index in filtered) {
            if (models.findIndex(_ => _.value === filtered[index].model) < 0) {
                models.push({
                    value: filtered[index].model
                });
            }
        }

        let rowsTmp = rows.slice()

        if (values.brand === null) {
            rowsTmp[rowsTmp.findIndex(_ => _.attribute === "model")].hidden = true
        }
        else {
            rowsTmp[rowsTmp.findIndex(_ => _.attribute === "model")].list = models
            rowsTmp[rowsTmp.findIndex(_ => _.attribute === "model")].hidden = false
        }

        setRows(rowsTmp)
    }
    const initRows = () => {
        let brands = [
            {
                value: "Marque",
                id: null
            },
            {
                value: "----------",
                id: null
            }
        ];
        let peripheral

        for(let index in AutomaticDrawerController._drawers) {
            peripheral = AutomaticDrawerController._drawers[index]

            if (brands.findIndex(_ => _.value === peripheral.brand) < 0)
                brands.push({ value: peripheral.brand });
        }

        let rowsTmp = rows.slice();

        rowsTmp[rowsTmp.findIndex(_ => _.attribute === "brand")].list = brands;

        setRows(rowsTmp);
    }
    const initValues = () => {
        controller.setFormValues(object, setValues, true)
    }
    const handleChange = (attribute, returnType, val, strict = false) => {
        let value = FormBuilder.buildVal(returnType, val)
        let filtered = rows.filter(row => row.attribute === attribute && row.inputType === "select" && row.returnType === "int")
        let index = value

        if (!strict && filtered.length > 0 && filtered[0].list.length > 0) {
            value = parseInt(filtered[0].list[index].id)

            if (filtered[0].list[index].type !== undefined && values[attribute.replace("_id", "_type")] !== undefined) {
                setValues(prev => ({
                    ...prev,
                    [attribute]: value,
                    [attribute.replace("_id", "_type")]: filtered[0].list[index].type
                }))
            }
            else {
                setValues(prev => ({
                    ...prev,
                    [attribute]: value
                }))
            }
        }
        else {
            filtered = rows.filter(row => row.attribute === attribute && row.inputType === "select" && row.returnType === "string")

            if (filtered.length > 0) {
                if (filtered[0].list.filter(_ => _.value === value && _.id !== undefined && _.id === null).length > 0)
                    value = null
            }

            if (attribute === "model") {
                let drawer = AutomaticDrawerController._drawers.filter(_ => _.model === value)

                if (drawer.length > 0) {
                    setValues(prev => ({
                        ...prev,
                        [attribute]: value
                    }))
                }
            }
            else {
                setValues(prev => ({
                    ...prev,
                    [attribute]: value
                }))
            }
        }
    }
    const reinitAllEdits = () => {
        setErrors([]);
    }
    const returnUpdates = () => {
        return controller.returnUpdatesFromCompare(object, values);
    }
    const check422Errors = errorDatas => {
        setGlobalError("Certaines données sont invalides");

        if(errorDatas !== undefined) {
            let keys = Object.keys(errorDatas);
            let fields = ["reference"];

            for(let item in fields)
                if(keys.includes(fields[item]))
                    defineErrors(fields[item], false);
        }
    }
    const defineErrors = (type, empty) => {
        let errorsTmp = errors.slice();

        switch (type) {
            case "name":
                if(empty) errorsTmp["name"] = "Vous devez saisir un nom";
                else errorsTmp["name"] = "Ce nom n'est pas valide";
                break;
            default: break;
        }

        setErrors(errorsTmp);
    }
    const handleReturnSave = (response, error) => {
        if(error) {
            if(error.response !== undefined) {
                if(error.response.status === 422)
                    check422Errors(error.response.data);
            }
            else
                setGlobalError("Une erreur s'est produite lors de l'enregistrement");
        }
        else {
            setReload(true);
            handleIndex();
        }

        setSaving(false);
    }
    const save = () => {
        const datas = returnUpdates();

        if(Object.keys(datas).length === 0) return;

        setSaving(true);

        controller._callback = handleReturnSave;
        controller.post(datas);
    }
    const callToSave = () => {
        setGlobalError(null)
        reinitAllEdits()
        save()
    }
    const handleSubmit = event => {
        if (event !== undefined)
            event.preventDefault();
        callToSave();
    }

    useEffect(() => {
        getLicenses();
        initValues();
    }, [])
    useEffect(() => {
        if (!loadingLicenses)
            initRows()
    }, [loadingLicenses])
    useEffect(() => {
        if (ref.current !== undefined) {
            if (ref.current.brand !== undefined && ref.current.brand !== values.brand)
                getModelsByBrand()
        }

        ref.current = values
    }, [values])
    useEffect(() => {
        if ((values.brand !== undefined && values.brand === null) && rows[rows.findIndex(_ => _.attribute === "brand")].length === 3) // if only one choice
            handleChange("brand", "string", rows[rows.findIndex(_ => _.attribute === "brand")].list[rows[rows.findIndex(_ => _.attribute === "brand")].list.length - 1].value)

    }, [rows])

    return (
        <div className="clearing">
            {
                reload && <Redirect to={ "/" + item } />
            }
            {
                loadingLicenses
                    ? <div className="wrapCenterLoader">
                        <LoaderCircle
                            display="loader restGETInForm"
                            strokeWidth="8"/>
                    </div>
                    : <form className="form" onSubmit={handleSubmit}>
                        {
                            globalError !== null && <p className="globalError">{globalError}</p>
                        }
                        {
                            rows.map((row, index) => (
                                <div key={ index } className="clearing">
                                    {
                                        (row.hidden === undefined || !row.hidden)
                                        && <div className="clearing">
                                            {
                                                row.noLabel === undefined
                                                && <label className={ row.classnameLabel }>{ row.label }</label>
                                            }
                                            {
                                                FormBuilder.buildInputByType(row, values, errors, handleChange, null, null, handleSubmit, null, null, null, index === 0)
                                            }
                                        </div>
                                    }
                                </div>
                            ))
                        }
                        <button className={"submit " + (saving ? "hide" : "")}>
                            {
                                saving
                                    ? "Enregistrement..."
                                    : "Enregistrer"
                            }
                            <LoaderCircle display="loader submitForm " hide={!saving ? "hide" : ""} strokeWidth="8" stroke="#FFFFFF" />
                        </button>
                        <Link to={ "/" + item }>
                            <button className="cancel align">Fermer</button>
                        </Link>
                        <div className="clearing" />
                    </form>
            }
        </div>
    )
}

export default FormStart;